export default "__VITE_ASSET__Zq823x2n__"